module.exports = require('./A11yVideoAudioPlayer.jsx');
